module.exports = __webpack_public_path__ + "img/jinhua.e012b8fe.png";